export const supportedFileTypes = [
  'csv',
  'doc',
  'docx',
  'jpg',
  'jpeg',
  'pdf',
  'png',
  'xls',
  'xlsx',
] as const;
